// Recovered compiled webpack factory 31693. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      hasAdjacentParameterIssues: function () {
        return n;
      },
      normalizeAdjacentParameters: function () {
        return a;
      },
      normalizeTokensForRegexp: function () {
        return o;
      },
      stripParameterSeparators: function () {
        return i;
      },
    }));
  let r = "_NEXTSEP_";
  function n(e) {
    return (
      "string" == typeof e &&
      !!(
        /\/\(\.{1,3}\):[^/\s]+/.test(e) || /:[a-zA-Z_][a-zA-Z0-9_]*:[a-zA-Z_][a-zA-Z0-9_]*/.test(e)
      )
    );
  }
  function a(e) {
    let t = e;
    return (t = t.replace(/(\([^)]*\)):([^/\s]+)/g, `$1${r}:$2`)).replace(
      /:([^:/\s)]+)(?=:)/g,
      `:$1${r}`,
    );
  }
  function o(e) {
    return e.map((e) =>
      "object" == typeof e &&
      null !== e &&
      "modifier" in e &&
      ("*" === e.modifier || "+" === e.modifier) &&
      "prefix" in e &&
      "suffix" in e &&
      "" === e.prefix &&
      "" === e.suffix
        ? { ...e, prefix: "/" }
        : e,
    );
  }
  function i(e) {
    let t = {};
    for (let [n, a] of Object.entries(e))
      "string" == typeof a
        ? (t[n] = a.replace(RegExp(`^${r}`), ""))
        : Array.isArray(a)
          ? (t[n] = a.map((e) => ("string" == typeof e ? e.replace(RegExp(`^${r}`), "") : e)))
          : (t[n] = a);
    return t;
  }
}
